import { render, staticRenderFns } from "./Y67TDownloadDocuments.vue?vue&type=template&id=8700cb54&scoped=true&"
import script from "./Y67TDownloadDocuments.vue?vue&type=script&lang=js&"
export * from "./Y67TDownloadDocuments.vue?vue&type=script&lang=js&"
import style0 from "./Y67TDownloadDocuments.vue?vue&type=style&index=0&id=8700cb54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8700cb54",
  null
  
)

export default component.exports